// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import './StudyCentresPage.css';
// import Navbar from './Navbar';
// import FooterSection from './FooterSection';

// export default function StudyCentresPage() {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedDistrict, setSelectedDistrict] = useState('All Districts');

//   const districts = [
//     'All Districts',
//     'Sivaganga',
//     'Chennai',
//     'Coimbatore',
//     'Madurai',
//     'Tiruchirappalli',
//     'Salem',
//     'Tirunelveli',
//     'Erode',
//     'Vellore',
//     'Puducherry',
//     'Bengaluru',
//     'Hyderabad'
//   ];

//   const centresData = [
//     {
//       id: 1,
//       name: 'CDOE Main Centre',
//       district: 'Sivaganga',
//       address: 'EDULEARNER Main Campus, Thiruvannamalai – 606601',
//       phone: '+91-4565-241386',
//       email: 'cdoe@edulearner.ac.in',
//       coordinator: 'Dr. R. Muthuswamy'
//     },
//     {
//       id: 2,
//       name: 'Chennai Study Centre',
//       district: 'Chennai',
//       address: '45, Anna Salai, Teynampet, Chennai – 600018',
//       phone: '+91-44-24354678',
//       email: 'chennai.cdoe@edulearner.ac.in',
//       coordinator: 'Prof. K. Subramanian'
//     },
//     {
//       id: 3,
//       name: 'Coimbatore Study Centre',
//       district: 'Coimbatore',
//       address: '12, Avinashi Road, Peelamedu, Coimbatore – 641004',
//       phone: '+91-422-2574231',
//       email: 'coimbatore.cdoe@edulearner.ac.in',
//       coordinator: 'Dr. S. Rajendran'
//     },
//     {
//       id: 4,
//       name: 'Madurai Study Centre',
//       district: 'Madurai',
//       address: '78, Bypass Road, SS Colony, Madurai – 625016',
//       phone: '+91-452-2380921',
//       email: 'madurai.cdoe@edulearner.ac.in',
//       coordinator: 'Prof. V. Meenakshi'
//     },
//     {
//       id: 5,
//       name: 'Trichy Study Centre',
//       district: 'Tiruchirappalli',
//       address: '23, Bharathidasan Salai, Thillai Nagar, Trichy – 620018',
//       phone: '+91-431-2740123',
//       email: 'trichy.cdoe@edulearner.ac.in',
//       coordinator: 'Dr. A. Palaniappan'
//     },
//     {
//       id: 6,
//       name: 'Salem Study Centre',
//       district: 'Salem',
//       address: '56, Omalur Road, Salem – 636007',
//       phone: '+91-427-2318458',
//       email: 'salem.cdoe@edulearner.ac.in',
//       coordinator: 'Prof. N. Krishnaswamy'
//     },
//     {
//       id: 7,
//       name: 'Tirunelveli Study Centre',
//       district: 'Tirunelveli',
//       address: '34, High Ground Road, Tirunelveli – 627011',
//       phone: '+91-462-2330789',
//       email: 'tirunelveli.cdoe@edulearner.ac.in',
//       coordinator: 'Dr. M. Sundaram'
//     },
//     {
//       id: 8,
//       name: 'Erode Study Centre',
//       district: 'Erode',
//       address: '89, Brough Road, Erode – 638001',
//       phone: '+91-424-2225871',
//       email: 'erode.cdoe@edulearner.ac.in',
//       coordinator: 'Prof. S. Loganathan'
//     },
//     {
//       id: 9,
//       name: 'Vellore Study Centre',
//       district: 'Vellore',
//       address: '11, Gandhi Nagar, Vellore – 632006',
//       phone: '+91-416-2245890',
//       email: 'vellore.cdoe@edulearner.ac.in',
//       coordinator: 'Dr. K. Anand'
//     },
//     {
//       id: 10,
//       name: 'Pondicherry Study Centre',
//       district: 'Puducherry',
//       address: '87, MG Road, Pondicherry – 605001',
//       phone: '+91-413-2234512',
//       email: 'pondicherry.cdoe@edulearner.ac.in',
//       coordinator: 'Prof. L. Vasudevan'
//     },
//     {
//       id: 11,
//       name: 'Bangalore Study Centre',
//       district: 'Bengaluru',
//       address: '102, Residency Road, Bangalore – 560025',
//       phone: '+91-80-25123456',
//       email: 'bangalore.cdoe@edulearner.ac.in',
//       coordinator: 'Dr. T. Ramakrishnan'
//     },
//     {
//       id: 12,
//       name: 'Hyderabad Study Centre',
//       district: 'Hyderabad',
//       address: '45, Begumpet, Hyderabad – 500016',
//       phone: '+91-40-27890123',
//       email: 'hyderabad.cdoe@edulearner.ac.in',
//       coordinator: 'Prof. B. Venkataraman'
//     }
//   ];

//   // Filtering Logic
//   const filteredCentres = centresData.filter((item) => {
//     const matchesSearch =
//       item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.address.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.district.toLowerCase().includes(searchTerm.toLowerCase());

//     const matchesDistrict =
//       selectedDistrict === 'All Districts' || item.district === selectedDistrict;

//     return matchesSearch && matchesDistrict;
//   });

//   return (
//         <>
//          <Navbar />
//     <div className="study-centres-page-wrapper">
      
//       {/* 1. Header Banner */}
//       <section className="centres-hero-banner">
//         <div className="banner-inner-container">
//           <nav className="breadcrumb-nav">
//             <Link to="/" className="breadcrumb-link">Home</Link> / <span>Study Centres</span>
//           </nav>
//           <h1>Study Centres</h1>
//           <p>280+ authorised study centres across India. Find the nearest one to you.</p>
//         </div>
//       </section>

//       {/* 2. Controls Section */}
//       <section className="centres-control-section">
//         <div className="centres-container">
          
//           <div className="filter-controls-row">
//             {/* Search Box */}
//             <div className="search-input-box">
//               <span className="search-icon">🔍</span>
//               <input
//                 type="text"
//                 placeholder="Search by city or centre name..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />
//             </div>

//             {/* Dropdown Filter */}
//             <div className="select-dropdown-wrapper">
//               <select
//                 value={selectedDistrict}
//                 onChange={(e) => setSelectedDistrict(e.target.value)}
//                 className="district-select"
//               >
//                 {districts.map((d, i) => (
//                   <option key={i} value={d}>
//                     {d}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           <div className="results-count-text">
//             {filteredCentres.length} centres found
//           </div>

//         </div>
//       </section>

//       {/* 3. Study Centres Cards Grid */}
//       <section className="centres-grid-section">
//         <div className="centres-container">
          
//           {filteredCentres.length > 0 ? (
//             <div className="centres-cards-grid">
//               {filteredCentres.map((centre) => (
//                 <div key={centre.id} className="centre-card">
                  
//                   <div className="centre-card-header">
//                     <div className="pin-icon-box">📍</div>
//                     <div className="title-block">
//                       <h3>{centre.name}</h3>
//                       <span className="district-tag">{centre.district}</span>
//                     </div>
//                   </div>

//                   <div className="centre-card-body">
//                     <div className="info-row">
//                       <span className="info-icon">🏢</span>
//                       <p>{centre.address}</p>
//                     </div>
//                     <div className="info-row">
//                       <span className="info-icon">📞</span>
//                       <p><a href={`tel:${centre.phone}`}>{centre.phone}</a></p>
//                     </div>
//                     <div className="info-row">
//                       <span className="info-icon">✉️</span>
//                       <p><a href={`mailto:${centre.email}`}>{centre.email}</a></p>
//                     </div>
//                   </div>

//                   <div className="centre-card-footer">
//                     <span className="coordinator-label">Coordinator:</span> {centre.coordinator}
//                   </div>

//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="no-results-box">
//               <h3>No study centres found matching your criteria.</h3>
//               <p>Try resetting your search input or select "All Districts".</p>
//             </div>
//           )}

//         </div>
//       </section>

//       {/* 4. Locate Us on Map Section */}
//       <section className="map-section">
//         <div className="centres-container">
//           <div className="centered-header">
//             <h2>Locate Us on Map</h2>
//           </div>

//           <div className="map-embed-wrapper">
//             <iframe
//               title="Thiruvannamalai Location Map"
//               src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d62432.88045952923!2d79.03848149258284!3d12.225284102928821!2m3!1f0!0!f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3abca220f8623ad9%3A0x6b772421370b395d!2sTiruvannamalai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1710000000000!5m2!1sen!2sin"
//               width="100%"
//               height="380"
//               style={{ border: 0, borderRadius: '12px' }}
//               allowFullScreen=""
//               loading="lazy"
//               referrerPolicy="no-referrer-when-downgrade"
//             ></iframe>
//           </div>
//         </div>
//       </section>

//     </div>
//         <FooterSection/>
//             </>
//   );
// }


import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './StudyCentresPage.css';
import Navbar from './Navbar';
import FooterSection from './FooterSection';

export default function StudyCentresPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDistrict, setSelectedDistrict] = useState('All Districts');
  const [universities, setUniversities] = useState([]);
  const [districts, setDistricts] = useState(['All Districts']);
  const [loading, setLoading] = useState(true);

  // Fetch dynamic study centres API
  useEffect(() => {
    const fetchStudyCentres = async () => {
      try {
        const response = await fetch('https://metapi.emedhatechnologies.com/api/courses/study-centres');
        const result = await response.json();

        if (result.success && Array.isArray(result.data)) {
          setUniversities(result.data);

          // Extract all unique districts from nested colleges & territorial jurisdictions
          const extractedDistricts = new Set();
          result.data.forEach((uni) => {
            if (uni.colleges && uni.colleges.length > 0) {
              uni.colleges.forEach((col) => {
                if (col.district) extractedDistricts.add(col.district);
              });
            } else if (uni.territorial_jurisdiction) {
              // Extract district name if present in jurisdiction text
              const firstPart = uni.territorial_jurisdiction.split('-')[0].trim();
              if (firstPart) extractedDistricts.add(firstPart);
            }
          });

          setDistricts(['All Districts', ...Array.from(extractedDistricts)]);
        }
      } catch (error) {
        console.error('Error fetching study centres:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStudyCentres();
  }, []);

  // Flatten universities into single card items for unified rendering
  const allCardItems = [];
  universities.forEach((uni) => {
    if (uni.colleges && uni.colleges.length > 0) {
      uni.colleges.forEach((col) => {
        allCardItems.push({
          id: `col-${col.id}`,
          universityName: uni.university_name,
          title: col.college_name,
          code: col.college_code,
          district: col.district || 'Tamil Nadu',
          address: uni.territorial_jurisdiction?.replace(/"/g, ''),
          phone: col.contact_number || uni.contact_number,
          email: col.email_address || uni.email_address,
          coordinator: col.coordinator_name || uni.coordinator_name
        });
      });
    } else {
      // If a university has 0 colleges, display the University itself as the Main Centre Card
      allCardItems.push({
        id: `uni-${uni.id}`,
        universityName: uni.university_name,
        title: `${uni.university_name} (Main Campus)`,
        code: uni.university_type || 'State University',
        district: uni.territorial_jurisdiction?.split('-')[0]?.trim() || 'Tamil Nadu',
        address: uni.territorial_jurisdiction?.replace(/"/g, ''),
        phone: uni.contact_number,
        email: uni.email_address,
        coordinator: uni.coordinator_name
      });
    }
  });

  // Filter items based on Search Term & District Dropdown
  const filteredCentres = allCardItems.filter((item) => {
    const matchesSearch =
      item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.universityName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.district.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.code.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesDistrict =
      selectedDistrict === 'All Districts' ||
      item.district.toLowerCase() === selectedDistrict.toLowerCase();

    return matchesSearch && matchesDistrict;
  });

  return (
    <>
      <Navbar />
      <div className="study-centres-page-wrapper">
        
        {/* 1. Header Banner */}
        <section className="centres-hero-banner">
          <div className="banner-inner-container">
            <nav className="breadcrumb-nav">
              <Link to="/" className="breadcrumb-link">Home</Link> / <span>Study Centres</span>
            </nav>
            <h1>Study Centres</h1>
            <p>Authorised learning support centres across India. Find the nearest one to you.</p>
          </div>
        </section>

        {/* 2. Controls Section */}
        <section className="centres-control-section">
          <div className="centres-container">
            
            <div className="filter-controls-row">
              {/* Search Box */}
              <div className="search-input-box">
                <span className="search-icon">🔍</span>
                <input
                  type="text"
                  placeholder="Search by city, centre name, or university..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              {/* District Filter Dropdown */}
              <div className="select-dropdown-wrapper">
                <select
                  value={selectedDistrict}
                  onChange={(e) => setSelectedDistrict(e.target.value)}
                  className="district-select"
                >
                  {districts.map((d, i) => (
                    <option key={i} value={d}>
                      {d}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="results-count-text">
              {loading ? 'Loading centres...' : `${filteredCentres.length} centres found`}
            </div>

          </div>
        </section>

        {/* 3. Study Centres Cards Grid */}
        <section className="centres-grid-section">
          <div className="centres-container">
            
            {loading ? (
              <div className="no-results-box">
                <h3>Loading study centres, please wait...</h3>
              </div>
            ) : filteredCentres.length > 0 ? (
              <div className="centres-cards-grid">
                {filteredCentres.map((item) => (
                  <div key={item.id} className="centre-card">
                    
                    {/* Top University Name Banner */}
                    <div className="university-top-badge">
                      🏛️ {item.universityName}
                    </div>

                    <div className="centre-card-header">
                      <div className="pin-icon-box">📍</div>
                      <div className="title-block">
                        <h3>
                          {item.title} {item.code ? `(${item.code})` : ''}
                        </h3>
                        <span className="district-tag">{item.district}</span>
                      </div>
                    </div>

                    <div className="centre-card-body">
                      {item.address && (
                        <div className="info-row">
                          <span className="info-icon">🏢</span>
                          <p>{item.address}</p>
                        </div>
                      )}
                      {item.phone && (
                        <div className="info-row">
                          <span className="info-icon">📞</span>
                          <p><a href={`tel:${item.phone}`}>{item.phone}</a></p>
                        </div>
                      )}
                      {item.email && (
                        <div className="info-row">
                          <span className="info-icon">✉️</span>
                          <p><a href={`mailto:${item.email}`}>{item.email}</a></p>
                        </div>
                      )}
                    </div>

                    <div className="centre-card-footer">
                      <span className="coordinator-label">Coordinator:</span> {item.coordinator || 'N/A'}
                    </div>

                  </div>
                ))}
              </div>
            ) : (
              <div className="no-results-box">
                <h3>No study centres found matching your criteria.</h3>
                <p>Try resetting your search input or select "All Districts".</p>
              </div>
            )}

          </div>
        </section>

        {/* 4. Locate Us on Map Section */}
        <section className="map-section">
          <div className="centres-container">
            <div className="centered-header">
              <h2>Locate Us on Map</h2>
            </div>

            <div className="map-embed-wrapper">
              <iframe
                title="Thiruvannamalai Location Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d62432.88045952923!2d79.03848149258284!3d12.225284102928821!2m3!1f0!0!f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3abca220f8623ad9%3A0x6b772421370b395d!2sTiruvannamalai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1710000000000!5m2!1sen!2sin"
                width="100%"
                height="380"
                style={{ border: 0, borderRadius: '12px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </section>

      </div>
      <FooterSection />
    </>
  );
}